module.exports = __webpack_public_path__ + "img/LOST-Q1.1d459572.jpg";